import React from 'react';
import {connect } from 'react-redux';
import {authenticationService, mainService, userService} from '../../../jwt/_services';
import {history, utilHelper} from '../../../jwt/_helpers';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    UncontrolledDropdown
} from 'reactstrap';
/*--------------------------------------------------------------------------------*/
/* Import images which are need for the HEADER                                    */
/*--------------------------------------------------------------------------------*/
import developicon from '../../../assets/images/develop.png';
import logolighticon from '../../../assets/images/logo/png/symbol-w.png';
import logolighttext from '../../../assets/images/logo/png/logotype-w.png';
import profilePhotoWhite from '../../../assets/images/icon/Icon-userWhite.svg';
import profilePhotoBlue from '../../../assets/images/icon/Icon-user.svg';
import {employeeService} from "../../../jwt/_services/hr/employeeService";
import {UserPasswordModal} from "../../../views/security/user/_passwordModal";
import {toDoTaskService} from "../../../jwt/_services/profile/toDoTaskService";
import {showLoader} from "../../../components/loader/loader";
import {Redirect} from "react-router-dom";


const mapStateToProps = state => ({
    ...state
});

class HeaderMain extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.showMobilemenu = this.showMobilemenu.bind(this);
        this.state = {
            currentUser:null,
            notifications: [],
            isOpen: false,
            loading: false,
            redirect: false
        };
        this.childRef = React.createRef();
        this.toggleMenu = this.toggleMenu.bind(this);
        this.goToMyNotifications = this.goToMyNotifications.bind(this);
        this.goToNotification = this.goToNotification.bind(this);
    }

    componentDidMount() {
        let user = (localStorage.getItem('currentUser') !== '' ? JSON.parse(localStorage.getItem('currentUser')) : null);

        const data = {
            ...user,
            name: '',
            lastName: '',
            employeeNumber: '',
        };

        userService.getCurrentUserInfo()
            .then( result => {
                try {
                    localStorage.setItem('userData', JSON.stringify(result || data));
                } catch (e) {
                    console.log(e);
                }

                this.setState({currentUser: result || data})

            })
            .catch(console.log)

        // mainService.getAllMyToDoTask().then(result => {
        //     if (result !== undefined && result !== null)
        //         this.setState({notifications: result});
        // }).catch(console.log);
    }

    /*--------------------------------------------------------------------------------*/
    /*To open Search Bar                                                              */

    /*--------------------------------------------------------------------------------*/
    toggleMenu() {
        document.getElementById('search').classList.toggle('show-search');
    }

    showModal = () => {
        this.childRef.current.showModal(this.state.currentUser);
    }
    /*--------------------------------------------------------------------------------*/
    /*To open NAVBAR in MOBILE VIEW                                                   */

    /*--------------------------------------------------------------------------------*/
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    /*--------------------------------------------------------------------------------*/
    /*To open SIDEBAR-MENU in MOBILE VIEW                                             */

    /*--------------------------------------------------------------------------------*/
    showMobilemenu() {
        document.getElementById('main-wrapper').classList.toggle('show-sidebar');
    }

    handleLogout = () => {
        authenticationService.logout().then(_ => {});
        history.push("/authentication/login");
    }

    showNavbar() {
        return (<NavbarBrand href="/modules/main">
            {<b className="logo-icon">
                <img
                    src={logolighticon}
                    width="45px"
                    height="20px"
                    alt="homepage"
                    className="light-logo"
                />
            </b>}
            <span className="logo-text">
                <img
                    width="148"
                    height="19"
                    src={logolighttext}
                    className="light-logo"
                    alt="homepage"
                />
            </span>
            {
                utilHelper.isDevelopEnvironment() && <img
                    width="30"
                    height="30"
                    src={developicon}
                    className="light-logo"
                    alt="develop"
                />
            }
        </NavbarBrand>);
    }

    goToMyNotifications() {
        this.setState({loading: true});
        const module = JSON.parse(localStorage.getItem('profileModule'));
        if (module) {
            mainService.getAllPermission({module: module});
            mainService.getMenuSideBar({ module : {id : module } }).then(
                menus => {
                    localStorage.setItem('menus', JSON.stringify(menus));
                    localStorage.setItem('module', JSON.stringify(module));
                    this.setState({loading: false, redirect: true});
                }
            ).catch(_ => {
                this.setState({loading: false});
            });
        }else {
            this.setState({loading: false});
        }
    }

    goToNotification(notificationId) {
        this.setState({loading: true});
        toDoTaskService.getItem(notificationId)
            .then(item => {
                const module = JSON.parse(localStorage.getItem('profileModule'));
                if (module) {
                    mainService.getAllPermission({module: module});
                    mainService.getMenuSideBar({ module : {id : module } }).then(
                        menus => {
                            localStorage.setItem('menus', JSON.stringify(menus));
                            localStorage.setItem('module', JSON.stringify(module));
                            localStorage.setItem('notificationItem', JSON.stringify(item));
                            this.setState({loading: false, redirect: true});
                        }
                    ).catch(_ => {
                        this.setState({loading: false});
                    });
                }else {
                    this.setState({loading: false});
                }
            });
    }


    render() {
        const {currentUser, notifications, redirect} = this.state;
        if (redirect) {
            return <Redirect to='/main/profile/todotask'/>;
        }
        return (
            <header
                className="topbar navbarbg"
                style={{background: "rgba(0, 0, 0, 0.1)"}}
                data-navbarbg={this.props.settings.activeNavbarBg}
            >
                {this.state.loading && showLoader()}
                <Navbar
                    className={
                        'top-navbar ' +
                        (this.props.settings.activeNavbarBg === 'skin6'
                            ? 'navbar-light'
                            : 'navbar-dark')
                    }
                    expand="md"
                    style={{background: "rgba(0, 0, 0, 0.01)"}}
                >
                    <div
                        className="navbar-header"
                        id="logobg"
                        // data-logobg={this.props.settings.activeLogoBg}
                    >
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Mobile View Toggler  [visible only after 768px screen]                         */}
                        {/*--------------------------------------------------------------------------------*/}
                        <span
                            className="nav-toggler d-block d-md-none text-white"
                            onClick={this.showMobilemenu}
                        >
							<i className="ti-menu ti-close"/>
						</span>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Logos Or Icon will be goes here for Light Layout && Dark Layout                */}
                        {/*--------------------------------------------------------------------------------*/}
                        {this.showNavbar()}
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Mobile View Toggler  [visible only after 768px screen]                         */}
                        {/*--------------------------------------------------------------------------------*/}
                        <span
                            className="topbartoggler d-block d-md-none text-white"
                            onClick={this.toggle}
                        >
							<i className="ti-more"/>
						</span>
                    </div>
                    <Nav className="ml-auto float-right" navbar>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Start Notifications Dropdown                                                   */}
                        {/*--------------------------------------------------------------------------------*/}
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav caret>
                                <i className="mdi mdi-bell"/>
                                {
                                    notifications?.length > 0 &&
                                    <div className="notify">
                                        <span className="heartbit"/> <span className="point"/>
                                    </div>
                                }
                            </DropdownToggle>
                            <DropdownMenu right className="mailbox">
                                <div className="p-4 text-dark shadow border-bottom">
                                    <h4 className="mb-0 font-weight-bold">
                                        {
                                            notifications?.length > 0 ? "Notificaciones" : "No tienes notificaciones"
                                        }
                                    </h4>
                                </div>
                                <div
                                    className="notifications message-center notifications position-relative ps-container ps-theme-default ps-active-y">
                                    {notifications?.map((notification, index) => {
                                        return (
                                            <span className="message-item" key={index} onClick={() => {
                                                this.goToNotification(notification.idTask)
                                            }}>
													<span className='btn btn-circle btn-success'>
														<i className="fas fa-user text-white"/>
													</span>
													<div className="mail-contnet">
														<h5 className="message-title">
                                                            {notification.name + " " + notification.lastName}
														</h5>
														<span className="mail-desc">Modelo : {notification.model}</span>
														<span className="time"> Accion: {notification.action}</span>
                                                        <span
                                                            className="time"> Fecha: {utilHelper.dateFormatter(notification.registerDate)}</span>
													</div>
												</span>
                                        );
                                    })}
                                </div>
                                {
                                    notifications?.length > 0 &&
                                    <span className="nav-link text-center mb-1 text-muted pointer"
                                          onClick={this.goToMyNotifications}>
                                            <strong>Mostrar todas las notificaciones</strong>
                                        </span>
                                }
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* End Notifications Dropdown                                                     */}
                        {/*--------------------------------------------------------------------------------*/}
                        {/*--------------------------------------------------------------------------------*/}
                        {/* End Messages Dropdown                                                          */}
                        {/*--------------------------------------------------------------------------------*/}
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Start Profile Dropdown                                                         */}
                        {/*--------------------------------------------------------------------------------*/}
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav caret className="pro-pic">
                                    <span>
                                       {
                                           currentUser?.name !== undefined ?
                                           currentUser?.name
                                           + " " +
                                           currentUser?.lastName : ''
                                       }
                                    </span>
                                <img
                                    src={profilePhotoWhite}
                                    alt="user"
                                    width="30"
                                />
                            </DropdownToggle>
                            <DropdownMenu right className="user-dd">
                                <div className="d-flex no-block align-items-center p-3 mb-2 border-bottom">
                                    <div className="">
                                        <img
                                            src={profilePhotoBlue}
                                            alt="user"
                                            className="rounded"
                                            width="60"
                                        />
                                    </div>
                                    <div className="ml-3">
                                        <h4 className="mb-0">  {
                                            currentUser?.name
                                            + " " +
                                            currentUser?.lastName
                                        }</h4>
                                        <p className="text-muted mb-0">  {
                                            currentUser?.employeeNumber
                                        }</p>
                                    </div>
                                </div>
                                <DropdownItem onClick={this.showModal}>
                                    <i className="fas fa-key mr-1 ml-1"/> Cambiar Contraseña
                                </DropdownItem>
                                <DropdownItem onClick={this.handleLogout}>
                                    <i className="fa fa-power-off mr-1 ml-1"/> Salir
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* End Profile Dropdown                                                           */}
                        {/*--------------------------------------------------------------------------------*/}
                    </Nav>

                </Navbar>
                {
                    <UserPasswordModal ref={this.childRef}/>
                }
            </header>


        );
    }
}

export default connect(mapStateToProps)(HeaderMain);
